module.exports = __webpack_public_path__ + "img/we.bef81879.webp";